import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import React from "react";
var __jsx = React.createElement;
import { TagChip } from 'components/common/material-ui/custom-components';
import { Close } from 'theme/icons';

var TagAutocompleteChip = function TagAutocompleteChip(_ref) {
  var label = _ref.label,
      getTagProps = _ref.getTagProps,
      index = _ref.index,
      deleteIcon = _ref.deleteIcon,
      isMultiple = _ref.isMultiple,
      horizontalScroll = _ref.horizontalScroll,
      title = _ref.title;
  return __jsx(TagChip, _extends({
    size: "small",
    label: label,
    title: title !== null && title !== void 0 ? title : label
  }, getTagProps({
    index: index
  }), deleteIcon === false ? {
    onDelete: undefined
  } : {}, {
    deleteIcon: deleteIcon ? __jsx(Close, null) : undefined,
    multiple: isMultiple,
    horizontalScroll: horizontalScroll
  }));
};

export default TagAutocompleteChip;